import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { IRelation } from '../../interfaces'
import { fetchRelations } from '../../../../services/dtServices'
import { fetchRelationsForGuest } from '../../../../services/guestServices'
import { useAppSelector } from '../../../../redux/hook'

export const useGetRelations = (
    entityTemplateId: string,
    orgId: string,
    refetchOnMount = true,
): UseQueryResult<IRelation[], Error> => {
    const isGuestUser =
        useAppSelector((state) => state.searchParams.isGuestUser) === 'true'
    return useQuery<IRelation[]>({
        queryKey: ['relations', entityTemplateId, orgId],
        queryFn: () => {
            if (!entityTemplateId) {
                return []
            }
            return isGuestUser
                ? fetchRelationsForGuest(entityTemplateId, orgId)
                : fetchRelations(entityTemplateId, orgId)
        },
        refetchOnWindowFocus: false,
        refetchOnMount,
    })
}
